import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PageMetric } from './page-layout.models';

@Component({
  selector: 'app-page-metric-strip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="page-metrics" aria-label="Page summary">
      @for (metric of metrics; track metric.label) {
        <div class="metric-tile" [class.success]="metric.tone === 'success'" [class.warn]="metric.tone === 'warn'" [class.info]="metric.tone === 'info'" [class.danger]="metric.tone === 'danger'">
          <span class="metric-label">{{ metric.label }}</span>
          <strong>{{ metric.value ?? '-' }}</strong>
          @if (metric.hint !== null && metric.hint !== undefined && metric.hint !== '') {
            <span class="metric-hint">{{ metric.hint }}</span>
          }
        </div>
      }
    </section>
  `,
  styles: [`
    .page-metrics {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
      gap: 0.75rem;
    }

    .metric-tile {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      min-height: 5.25rem;
      min-width: 0;
      padding: 1rem;
      border: 1px solid var(--app-border, #dfe7f3);
      border-radius: 8px;
      background: var(--app-surface, #ffffff);
      box-shadow: 0 10px 24px var(--app-shadow-soft, rgba(15, 23, 42, 0.05));
    }

    .metric-label,
    .metric-hint {
      color: var(--app-muted, #64748b);
      font-size: 0.82rem;
      font-weight: 600;
    }

    strong {
      color: var(--app-text, #172033);
      font-size: 1.65rem;
      line-height: 1.05;
      overflow-wrap: anywhere;
    }

    .metric-tile.success strong {
      color: var(--app-success-strong, #047857);
    }

    .metric-tile.warn strong {
      color: var(--app-warn-strong, #b45309);
    }

    .metric-tile.info strong {
      color: var(--app-info-strong, #0369a1);
    }

    .metric-tile.danger strong {
      color: var(--app-danger-strong, #b91c1c);
    }

    @media (max-width: 560px) {
      .page-metrics {
        grid-template-columns: 1fr;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageMetricStripComponent {
  @Input() metrics: PageMetric[] = [];
}
